import React from "react"
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import Heading from "@amzn/meridian/heading";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Icon from "@amzn/meridian/icon";
import exportToken from "@amzn/meridian-tokens/base/icon/export-small";
import Link from "@amzn/meridian/link";
import Box from "@amzn/meridian/box";
import {EXTERNAL_LINKS} from "./Constants";
import {getUTRRegion, renderElementSeparator} from "./Util";

const renderExternalLinks = () => {
    return (<Row>
        {EXTERNAL_LINKS.map((item, index) => {
            return (
                <Row>
                    {index > 0 && renderElementSeparator()}
                    <Link target={"_blank"} rel={"noopener noreferrer"}
                          type="secondary" href={item.links[getUTRRegion()]}>
                        <b> <FormattedMessage id={item.id}/> </b>
                        <Icon tokens={exportToken}/>
                    </Link>
                </Row>
            )
        })}
    </Row>)
}

/**
 * Returns the page heading and description
 * @param head
 * @param headAlt
 * @param desc
 * @param descAlt
 * @return JSX.Element
 */

const PageHeader = ({head, headAlt, desc, descAlt}) => {
    return (
        <Column spacing={"none"}>
            <Heading level={2} type="h400" alignment="left">
                <FormattedMessage id={head} defaultMessage={headAlt}/>
            </Heading>
            <Row widths={["fit", "fill", "fit"]} overflowX={"scroll"}>
                <Text color={"secondary"}><FormattedMessage id={desc} defaultMessage={descAlt}/></Text>
                <Box/>
                {renderExternalLinks()}
            </Row>
        </Column>
    )
}

PageHeader.propTypes = {
    head: PropTypes.string,
    headAlt: PropTypes.string,
    desc: PropTypes.string,
    descAlt: PropTypes.string,
}

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/util/PageHeader.js